import React from "react";
import Icon from "./Icon";

// I² Visual Identity v1, M1.5 channel icons (2026-04-29).
//
// Replaces the emoji glyphs in theme/colors.js::CHANNEL_ICONS at every
// consumer site. The map below pins channel name → semantic Icon
// wrapper key — same indirection pattern as IconTile so future icon-
// library swaps don't require touching 6+ consumer files again.

const CHANNEL_TO_ICON = {
  voice:    "channel.voice",
  sms:      "channel.sms",
  whatsapp: "channel.whatsapp",
  chat:     "channel.chat",
  web:      "channel.web",
  email:    "channel.email",
  webhook:  "channel.webhook",
};

/**
 * <ChannelIcon channel="voice" size={14} />
 * Drop-in replacement for the emoji-glyph pattern that was rendered as
 * <span style={{ fontSize:14 }}>{CHANNEL_ICONS[c]}</span>.
 */
export default function ChannelIcon({ channel, size = 14, color, style, ...rest }) {
  const name = CHANNEL_TO_ICON[channel];
  if (!name) return null;
  return <Icon name={name} size={size} color={color} style={style} {...rest} />;
}
